import React, {useEffect, useState} from "react";
import {Button, Container, Label, Modal, Segment} from "semantic-ui-react";
import AppListPage from "../../common/AppListPage";
import {PaginateOptions} from "../../../agent";
import {Patient} from "../../dashboard";
import {PatientsDataProvider} from "../service/PatientsDataProvider";
import {Utils} from "../../../helpers/Utils";
import {AppMode, DoctorTitleCase, getDoctorTitle, getPatientTitle, PatientTitleCase} from "../../../utils/common";
import {firstLetterToUpperCase} from "../../workTablePatients/PatientsList";

interface Props {
    patientIds?: string[],
    onChange?: (value: string[]) => void,
    disabled: boolean
}

const SurveyCampaignPatients = (props: Props) => {
    const [patientIds, setPatientIds] = useState<string[]>(props.patientIds ?? []);
    const [showSelectList, setShowSelectList] = useState(false);

    useEffect(() => {
        if (props.onChange)
            props.onChange(patientIds);
    }, [patientIds]);

    return <>
        {showSelectList &&
        <Modal open={showSelectList}
               onClose={() => setShowSelectList(false)}>
            <Modal.Content>
                <Container>
                    <AppListPage<Patient, PaginateOptions>
                        provider={new PatientsDataProvider()}
                        hideMenu={true}
                        multiSelect={true}
                        listOptions={{page: 1, limit: 10, search: ""}}
                        columns={[
                            {key: "name", name: `ФИО`, accessor: (item) => `${item.surname} ${item.name} ${item.middlename}`},
                            {key: "doctorName", name: Utils.vomode() != AppMode.STUDENT ? firstLetterToUpperCase(getDoctorTitle(DoctorTitleCase.im)) : "Карьерный советник"},
                            {key: "tel", name: "Телефон"}
                        ]}
                        selectedIds={patientIds}
                        onSelectionChanged={(selection) => setPatientIds(selection.selectedIds)}
                    />
                </Container>
            </Modal.Content></Modal>}
        <Segment padded color={"orange"}>
            <Label circular size={"large"}><b>{patientIds.length}</b></Label> {getPatientTitle(PatientTitleCase.ov)} выбрано
            <Button floated={"right"} size={"small"} color={"teal"} content={"Изменить выбор"}
                    type={"button"}
                    disabled={props.disabled}
                    onClick={() => setShowSelectList(true)}/>
        </Segment>
    </>;
}


export default SurveyCampaignPatients;